import {
	rootNavbarEl,
	setCookie,
	getCookie,
	eraseCookie,
	createFlag,
	createIcon,
	getRelativePosition,
	clickEvent,
	addHash,
	deleteHash
} from '../helpers'

const languageSelector = () => {
	const selectorInit = () => {
		let selectorCountriesRootEl = rootNavbarEl.querySelector('.selector--countries')
		let selectorLanguagesRootEl = rootNavbarEl.querySelector('.selector--languages')

		if (selectorCountriesRootEl && selectorLanguagesRootEl) {
			let selectorWrapper = rootNavbarEl.querySelector(".selector--wrapper")
			let selectorCloseBtn = rootNavbarEl.querySelector(".selector--close")
			let selectorTrigger = rootNavbarEl.querySelector(".selector--trigger")
			let selectorSubmitBtn = rootNavbarEl.querySelector("#selector--submit")

			// temp fix, remove when all pages will be on gutenberg
			let selectorTriggerFlag = selectorTrigger.querySelector('svg > use')
			let selectorTriggerFlagHref = selectorTriggerFlag.getAttributeNS('http://www.w3.org/1999/xlink', 'href')
			let rawFlagUrl = deleteHash(selectorTriggerFlagHref)
			let selectorTriggerFlagUrl = addHash(rawFlagUrl, getCookie('pll_language'))
			selectorTriggerFlag.setAttributeNS('http://www.w3.org/1999/xlink', 'href', selectorTriggerFlagUrl)


			let browserLang = window.navigator.language
			let defaultData = selectorData.filter((item) => item.code === browserLang.slice(0, 2))
			let tempCountry = (defaultData.length > 0) ? defaultData[0].label : 'United Kingdom (UK)'
			let tempCountryCode = (defaultData.length > 0) ? defaultData[0].code : 'gb'
			let tempLanguage = window.globalJS.polylangDefaultLanguage

			if (!getCookie('active_country')) {
				setCookie('active_country', tempCountry, 86400)
			}

			if (!getCookie('active_country_code')) {
				setCookie('active_country_code', tempCountryCode, 86400)
			}

			const hasTranslatedUrl = (lang) => {
				return document.querySelector(`link[hreflang=${lang}]`) ? true : false;
			}

			const getUrlIfExists = (inputValue) => {
				// get all the link elements with rel="alternate"
				let links = document.querySelectorAll('link[rel="alternate"]');

				for (let link of links) {
					// If the provided inputValue is 'en', look for the hreflang attribute instead
					if (inputValue === 'en' && link.getAttribute('hreflang') === 'en') {
						return link.href;
					}

					// For other values, check the URL segment
					let linkPath = new URL(link.href).pathname.slice(1); // get the path after the domain
					let linkPathFirstSegment = linkPath.split('/')[0];   // get the first segment of the path

					if (linkPathFirstSegment === inputValue) {
						return link.href;
					}
				}

				return null;
			}


			const saveCurrencyToSession = async (currency) => {
				const url = `${window.globalJS.homeUrl}/wp-json/tedee/save-currency/${currency}`;

				try {
					const response = await fetch(url);

					if (!response.ok) {
						throw new Error("Network response was not ok");
					}

					const data = await response.json();
					return data;
				} catch (error) {
					console.error(error);
				}
			}

			// firefox fix for :has css method
			const highlightActiveElement = (selector, el) => {
				let items = document.querySelectorAll(`${selector} .selector--item`)
				items.forEach((item) => {
					item.classList.remove("active")
					item.children[1].checked = false
				})
				el.classList.add("active")
				el.children[1].checked = true
			}

			const injectLanguageItems = () => {
				selectorLanguagesRootEl.innerHTML = ''

				let country = selectorCountriesRootEl.querySelector('.selector--item.active')
				let filteredCountry = selectorData.filter((item) => item.label === country.children[1].value)
				let countryLanguages = filteredCountry[0].languages
				let isLanguageSelected = false;

				countryLanguages.forEach((item) => {

					let el = document.createElement('div')
					let elClass = getCookie('pll_language') === item.hreflang ? 'active' : 'inactive'

					if (elClass === 'active') {
						 isLanguageSelected = true;
					} else if (countryLanguages.length === 1) {
						elClass = 'active';
						isLanguageSelected = true;
					}

					el.classList.add('selector--item', elClass)
					el.innerHTML = `
						${createFlag(item.hreflang)}
						<input id="language-${item.code}" type="radio" name="language" data-target="${item.hreflang}" value="${item.hreflang}" />
						<label for="language-${item.code}">
							${item.label}
							<div>
								<div class="selector--check">
									${createIcon('check')}
								</div>
							</div>
						</label>
					`

					if (el.classList.contains('active')) {
						highlightActiveElement('.selector--languages', el)
					}

					el.addEventListener('click', (e) => {
						const selectorSubmitBtns = rootNavbarEl.querySelectorAll("#selector--submit");

						selectorSubmitBtns.forEach(function(button) {
							button.disabled = false;
						});

						highlightActiveElement('.selector--languages', el)
					})
					selectorLanguagesRootEl.appendChild(el)

				});

				const selectorSubmitBtns = rootNavbarEl.querySelectorAll("#selector--submit");

				if (!isLanguageSelected) {
					selectorSubmitBtns.forEach(function(button) {
						button.disabled = true;
					});
				} else {
					selectorSubmitBtns.forEach(function(button) {
						button.disabled = false;
					});
				}
			}

			let countryItems = selectorWrapper.querySelectorAll('.selector--countries .selector--item')
			countryItems.forEach((item) => {
				item.addEventListener('click', (e) => {
					highlightActiveElement('.selector--countries', item)
					injectLanguageItems()
				})
			})

			let languageItems = selectorWrapper.querySelectorAll('.selector--languages .selector--item')
			languageItems.forEach((item) => {
				item.addEventListener('click', (e) => {
					highlightActiveElement('.selector--languages', item)
				})
			})

			selectorTrigger.addEventListener("click", (e) => {

				let selectorTriggerPosLeft = selectorTrigger.offsetLeft
				let selectorTriggerPosTop = selectorTrigger.offsetTop
				let selectorTriggerHeight = selectorTrigger.clientHeight
				let selectorTriggerWidth = selectorTrigger.clientWidth
				document.documentElement.style.setProperty('--selectorTriggerPosLeft', `${selectorTriggerPosLeft}px`)
				document.documentElement.style.setProperty('--selectorTriggerPosTop', `${selectorTriggerPosTop}px`)
				document.documentElement.style.setProperty('--selectorTriggerHeight', `${selectorTriggerHeight}px`)
				document.documentElement.style.setProperty('--selectorTriggerWidth', `${selectorTriggerWidth}px`)

				selectorTrigger.classList.toggle('active')
				selectorWrapper.classList.toggle("active")
				rootNavbarEl.closest('body').querySelector('#page').classList.toggle('active--selector')
				// rootNavbarEl.parentElement.classList.toggle('active--selector')

				let active_country = decodeURI(getCookie('active_country'));
				let active_country_code = getCookie('active_country_code');
				let countryItem = selectorWrapper.querySelector(`input[type="radio"][name="country"][value="${active_country}"]`);
				let pll_language = getCookie('pll_language');

				if (!countryItem) {
					let tempItem = selectorWrapper.querySelector(`input[type="radio"][name="country"][data-default="${pll_language}"]`);

					if (tempItem.dataset.default === active_country_code || tempItem.dataset.default === pll_language) {
						countryItem = tempItem
					}
				}

				if(countryItem) {
					highlightActiveElement('.selector--countries', countryItem.parentNode)
				}

				let countriesWrapper = selectorWrapper.querySelector(".selector--countries")
				let activeCountryItem = countriesWrapper.querySelector(".selector--item.active")

				if(countriesWrapper && activeCountryItem) {
					countriesWrapper.scrollTo({
						top: getRelativePosition(activeCountryItem).top,
						behavior: "smooth",
					})
				activeCountryItem.children[1].dispatchEvent(clickEvent)
				}
			})

			const fetchPolylangHomeUrl = async (lang) => {
				try {
					const response = await fetch(window.globalJS.ajaxUrl, {
						method: 'POST',
						headers: {'Content-Type': 'application/x-www-form-urlencoded'},
						credentials: "same-origin",
						body: `action=get_polylang_home_url&langCode=${lang}`,
					})
					const data = await response.json()
					return data
				} catch (error) {
					console.error(error)
					return { success: false, error: error.message }
				}
			}

			selectorSubmitBtn.addEventListener("click", (e) => {
				e.preventDefault()

				let selectedLanguage = rootNavbarEl.querySelector('.selector--languages .selector--item.active > input')
				let selectedCountry = rootNavbarEl.querySelector('.selector--countries .selector--item.active > input')

				saveCurrencyToSession(selectedCountry.dataset.currency).then(() => {

					setCookie("active_country", selectedCountry.value, 86400)
					setCookie("active_country_code", selectedCountry.dataset.code, 86400)
					// setCookie("wmc_current_currency", selectedCountry.dataset.currency, 86400)
					// setCookie("wmc_current_currency_old", selectedCountry.dataset.currency, 86400)
					setCookie('pll_language', selectedLanguage.value, 86400)

					let targetUrl = getUrlIfExists(selectedLanguage.value);

					if (targetUrl) {
						window.location.href = targetUrl
					} else {
						fetchPolylangHomeUrl(selectedLanguage.value).then(data => {
							window.location.href = data.data
						})
					}

				})

			})

			const closeSelector = (e) => {
				if (selectorWrapper.classList.contains("active")) {
					if (e.key == "Escape" || e.key == "Esc" || e.keyCode == 27) {
						selectorWrapper.classList.toggle("active")
						selectorTrigger.classList.toggle('active')
						rootNavbarEl.closest('body').querySelector('#page').classList.toggle('active--selector')
						// rootNavbarEl.parentElement.classList.toggle('active--selector')
					} else {
						selectorWrapper.classList.toggle("active")
						selectorTrigger.classList.toggle('active')
						rootNavbarEl.closest('body').querySelector('#page').classList.toggle('active--selector')
						// rootNavbarEl.parentElement.classList.toggle('active--selector')
					}
				}
			}
			selectorCloseBtn.addEventListener("click", closeSelector)
			window.addEventListener("keydown", closeSelector)
		}
	}


	const fetchSelectorJson = async () => {
		const response = await fetch(window.globalJS.themeUrl + '/src/js/selector.json')
		const data = await response.json()
		return data
	}


	let selectorData = undefined
	fetchSelectorJson()
		.then(data => selectorData = data)
		.then(selectorInit)

}

export default languageSelector
